import { Navigate } from 'react-router-dom';

import { ProjectType } from '@/api/rest/resources/types/project';
import { usePathSet } from '@/hooks/usePathSet';
import { useProjectDetailById } from '@/pages/shared/hooks/useProjectDetailById';

import { ConservationProjectPage } from './pages/conservation/shared/pages/project/ConservationProjectPage';

export const ProjectPage = () => {
  const project = useProjectDetailById().data;
  const pathSet = usePathSet();

  if (project.type !== ProjectType.conservation) {
    return <Navigate to={pathSet.home} replace />;
  }

  return <ConservationProjectPage />;
};
